var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 27.9998C4.66699 17.0004 4.66699 11.5007 8.08408 8.08359C11.5012 4.6665 17.0009 4.6665 28.0003 4.6665C38.9998 4.6665 44.4995 4.6665 47.9166 8.08359C51.3337 11.5007 51.3337 17.0004 51.3337 27.9998C51.3337 38.9993 51.3337 44.499 47.9166 47.9161C44.4995 51.3332 38.9998 51.3332 28.0003 51.3332C17.0009 51.3332 11.5012 51.3332 8.08408 47.9161C4.66699 44.499 4.66699 38.9993 4.66699 27.9998Z",
    stroke: "#AEBEF4",
    strokeWidth: 2.91667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.333 32.6668L21.6831 27.3167C22.5943 26.4055 24.0717 26.4055 24.9829 27.3167L28.6831 31.0169C29.5943 31.9281 31.0717 31.9281 31.9829 31.0169L39.6663 23.3335M39.6663 23.3335V29.1668M39.6663 23.3335H33.833",
    stroke: "#AEBEF4",
    strokeWidth: 2.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.b28ebbc611463799022d4e617dc1bfc0.svg";
export { ForwardRef as ReactComponent };